import { flagFactory } from '../icon';
import Svg from './us.svg';

export default flagFactory(Svg);